import script from "./ChatDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatDialog.vue?vue&type=script&setup=true&lang=js"

import "./ChatDialog.vue?vue&type=style&index=0&id=59f6228c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59f6228c"]])

export default __exports__